<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-os-type-config-relate">
    <div
      :class="['sky-os-type-config-relate__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.useRange"
        popper-class="sky-os-type-config-relate__autocomplete"
        class="sky-os-type-config-relate__select"
        filterable
      >
        <el-option v-for="(item, index) in useRangeList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>

      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.useScene"
        popper-class="sky-os-type-config-relate__autocomplete"
        class="sky-os-type-config-relate__select"
        filterable
      >
        <el-option v-for="(item, index) in useSceneList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>

      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.productId"
        popper-class="sky-os-type-config-relate__autocomplete"
        class="sky-os-type-config-relate__select"
        filterable
      >
        <el-option v-for="(item, index) in productList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>

      <i class="el-icon-arrow-right" />
      <el-input
        :ref="item.remarks"
        popper-class="sky-os-type-config-relate__autocomplete"
        class="sky-os-type-config-relate__select"
        v-model="item.remarks"
        placeholder="备注说明"
      >
      </el-input>

      <i class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
    </div>

    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加配置
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { COMMON_MNG, PRODUCT_MNG } from '@/api/apiModules'

export default {
  name: 'SkyOsTypeConfigRelate',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      variableArr: [
        {
          useRange: null,
          useScene: null,
          productId: null,
          remarks: null
        }
      ],
      loading: false,
      useRangeList: [],
      useSceneList: [],
      productList: []
    }
  },
  created() {
    this.variableArr = this.value ? this.value : []
  },
  mounted() {
    action(COMMON_MNG, 'useRange').then(response => {
      this.useRangeList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
    })
    action(COMMON_MNG, 'useScene').then(response => {
      this.useSceneList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
    })
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('支持的配置')))
              break
            }
          }
        }
        if (this.isDuplicate()) {
          hasError = true
          callback(new Error(this.$t('支持的配置组合不能重复')))
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.variableArr = this.value
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.useRange && item.useScene && item.productId
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const combination = obj['useRange'] + '-' + obj['useScene'] + '-' + obj['productId']
          if (set.has(combination)) {
            return true
          } else {
            set.add(combination)
          }
        })
      }
    },
    handleAdd() {
      this.variableArr.push({
        useRange: null,
        useScene: null,
        productId: null,
        remarks: null
      })
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(os-type-config-relate) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 220px;
  }
  @include e(select) {
    width: 220px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
